var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#070601","d":"M87.12 0C39.082 0 0 39.082 0 87.12s39.082 87.12 87.12 87.12 87.12-39.082 87.12-87.12S135.157 0 87.12 0zm0 159.305c-39.802 0-72.185-32.383-72.185-72.185S47.318 14.935 87.12 14.935s72.185 32.383 72.185 72.185-32.384 72.185-72.185 72.185z","key":0}),React.createElement("path",{"fill":"#070601","d":"M120.83 53.414c-2.917-2.917-7.647-2.917-10.559 0L87.12 76.568 63.969 53.414c-2.917-2.917-7.642-2.917-10.559 0s-2.917 7.642 0 10.559l23.151 23.153-23.152 23.154c-2.917 2.917-2.917 7.642 0 10.559 1.458 1.458 3.369 2.188 5.28 2.188s3.824-.729 5.28-2.188L87.12 97.686l23.151 23.153c1.458 1.458 3.369 2.188 5.28 2.188s3.821-.729 5.28-2.188c2.917-2.917 2.917-7.642 0-10.559L97.679 87.127l23.151-23.153c2.917-2.917 2.917-7.643 0-10.56z","key":1})]);
}

Close.defaultProps = {"viewBox":"0 0 174.239 174.239"};

module.exports = Close;

Close.default = Close;
